// 业务订单
export default {
  businessOrder: {
    search: {
      dateStart: '创建开始日期',
      dateEnd: '创建结束日期',
    },
    list: {
      // sxp 添加 TAPD ID1001044
      supplierName: '供应链主体',
      createBy: '创建人',
      businessDepartmentCode: '业务部门',
      sortNo: '序号',
      orderNo: '业务订单号',
      purchaseNo: '采购号',
      salesNo: '销售号',
      contractType: '合同类型',
      partnerNo: '供应商',
      customer: '客户',
      tradeType: '贸易类型',
      businessType: '业务性质',
      externalContractNo: '外部合同号',
      businessDepartment: '业务部门',
      createTime: '创建日期',
      createTimeStart: '创建开始日期',
      createTimeEnd: '创建结束日期',
      contractNumber: '合同数量',
      contractNumberSearch: '合同数量（吨）',
      purchaseNumber: '采购数量（吨）',
      salesNumber: '销售数量（吨）',
      storageNo: '仓库',
      priceIdentify: '价格标识',
      salesBatch: '结算批次',
      contractPrice: '合同单价',
      contractPriceSearch: '合同单价',
      productNo: '商品描述',
      salesMan: '业务员',
      operateMan: '操作人',
      contractNo: '合同/意向单号',
      totalContractPriceTax: '合同价税合计金额',
      totalVariablePriceTax: '变动价税合计金额',
      unit: '单位',
      createBtn: '创建业务订单',
      exportBtn: '导出列表',
      contractDetailNo: '合同行',
      detail: '业务订单详情',
      businessDepartmentName: '业务部门',
      gmtCreate: '创建日期',
      remark: '备注',
    },
    add: {
      relatedPurchase: '采购合同关联',
      relatedSales: '销售合同关联',
      attachmentList: '附件上传',
      purchaseLabel: '采购合同总数量',
      salesLabel: '销售合同总数量',
    },
  },
};
